import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=4d89a70f"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"
import style0 from "./Multiselect.vue?vue&type=style&index=0&id=4d89a70f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports